var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTasksIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 27 27",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 13.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 7h-12C6.673 7 6 7.648 6 8.444v10.112C6 19.352 6.673 20 7.5 20h12c.827 0 1.5-.648 1.5-1.444V8.444C21 7.648 20.327 7 19.5 7Zm-.75 2.889v1.444H15V9.89h3.75ZM15 12.778h3.75v1.444H15v-1.444Zm-7.5 5.778V8.444h5.25v10.112H7.5Z",
  fill: "currentColor"
})));
export { SvgTasksIcon as ReactComponent };
export default __webpack_public_path__ + "bb507445cb40bb2aaa8c688b2b2bd7d2.svg";